export default "<a class=\"app-store\" target=\"_blank\" data-bind=\"attr: { href: appStoreURL }, visible: appStoreURL\">\n  <div></div>\n</a>\n";